var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"div__carousell"},[_c('transition',{attrs:{"name":"slide-left"}},[_vm._l((_vm.images),function(i,index){return [(_vm.active === index)?_c('div',{key:index},[_c('img',{attrs:{"src":i}})]):_vm._e()]})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }